import type { Action } from 'redux';
import NotificationActions from '../../../../main/actions/NotificationActions';
import dash_api from '../../../../main/support/dash_api';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';
import type { GetAvailableOptimizationsResponseActionPayload } from '../SKANPostbacksConversionMapping.types';

const GetAvailableOptimizations = new ReduxAsyncAction<
  'GET_AVAILABLE_OPTIMIZATIONS',
  void,
  GetAvailableOptimizationsResponseActionPayload
>('GET_AVAILABLE_OPTIMIZATIONS');

GetAvailableOptimizations.registerRequest(async () => {
  try {
    const response = await dash_api.get<GetAvailableOptimizationsResponseActionPayload>(
      `/v1/skadnetworkv2/mapping-optimizations-info`
    );

    return response.data;
  } catch (error) {
    NotificationActions.showNotification('Cannot get information about available optimizations. Please try again.', 'error');

    throw error;
  }
});

export const GET_AVAILABLE_OPTIMIZATIONS = GetAvailableOptimizations.actionNamespaceConstants;

export const getAvailableOptimizations = GetAvailableOptimizations.request;

export type GetAvailableOptimizationsRequestAction = Action<typeof GET_AVAILABLE_OPTIMIZATIONS.request>;

export type GetAvailableOptimizationsResponseAction = Action<typeof GET_AVAILABLE_OPTIMIZATIONS.response> & {
  data: GetAvailableOptimizationsResponseActionPayload;
};
